module.exports = __webpack_public_path__ + "img/doc.3595ce3b.svg";